import { render, staticRenderFns } from "./comp_dpc-DynamicBanner.vue?vue&type=template&id=657b7efc&scoped=true&"
import script from "./comp_dpc-DynamicBanner.vue?vue&type=script&lang=js&"
export * from "./comp_dpc-DynamicBanner.vue?vue&type=script&lang=js&"
import style0 from "./comp_dpc-DynamicBanner.vue?vue&type=style&index=0&id=657b7efc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657b7efc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
